module.exports = __webpack_public_path__ + "static/img/title@2x.20d3265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ktbPopularize/title@2x.png
// module id = xADb
// module chunks = 70